<template>
  <div>
    <AlertWraper
      :content="content"
      :type="content_type"
    />
      <div class="campaign-data w-100">
        <h2>Dados da campanha</h2>
        <!-- begin: OTHER campaign types upsert -->
        <p>
          <strong>Nome:</strong> {{ campaign?.name }}<br/>
          <strong>Status:</strong> {{ campaign.status | formatCampaignStatus }}<br/>
          <strong>Tipo:</strong> {{ campaign.type | formatCampaignType }}<br/>
          <strong>Valor:</strong> {{ campaign.amount / 100 | formatMoney }}<br/>
          <strong>Meta de CPV:</strong> {{ campaign.cpv_target_amount / 100 | formatMoney }}
        </p>

        <hr>
      </div>

    <h2>Dados dos criativos</h2>
    <div class="creatives-data mt-10 pb-5 d-inline-flex col-12">
      <div class="d-flex flex-wrap gap-3 justify-content-between">
        <div class="audio-data col-5 " v-for="(audio, index) in audios" :key="index">
          <h3 class="mb-5">Banner</h3>
          <img class="mb-5" :src="audio.companion_creative.file" width="200" :alt="audio.companion_creative.name">
          <h3 class="mb-5">Audio</h3>
          <audio class="d-block mb-5" :src="audio.file" controls>
            Seu navegador não suporta o elemento de áudio.
          </audio>
          <div class="lh-1 mt-4">
            <p><strong>Nome:</strong> {{ audio?.name }}</p>
            <p><strong>Status:</strong> {{ audio.status | formatCampaignStatus }}</p>
            <p><strong>ID na plataforma:</strong> {{ audio?.google_id }}</p>
          </div>
        </div>
      </div>
    </div>
    <hr>

    <div class="d-block w-100 mt-15">
      <h2> Cadastrar campanha na plataforma {{ campaign.platform }} </h2>
      <p>Finalize o cadastro da campanha na plataforma do parceiro e, por fim, inclua o ID da line abaixo.</p>
      <div class="text-center mt-5">
        <a
          :href="`https://displayvideo.google.com/ng_nav/p/660702863/a/${campaign.advertiser.google_id}/c/${campaign.platform_id}/io/${currentPackage?.platform_id}/explorerlis`"
          class="btn btn-sm btn-primary"
          target="_blank"
        >
          Cadastrar
        </a>
      </div>
    </div>
    <hr>
      <!-- end: OTHER campaign types upsert -->

    <div class="mt-8">
      <h2> Vincular Campanha </h2>
      <form @submit.prevent="submit" class="mt-2">
        <div class="form-group mb-3 col-lg-4">
          <label class="form-label text-start">Insira o ID da line na plataforma {{ campaign.platform }}</label>
          <p class="mt-2">
            <strong>Nome da line:</strong> Line - {{ campaign.name }}
          </p>
          <input type="text" class="form-control" placeholder="ID da linha" v-model.trim="form.platform_id"/>
        </div>
        <div class="mt-3 text-center">
          <Button
            type="submit"
            class="btn btn-primary"
            :loading="loader"
          >
            Enviar
          </Button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  name: 'UpsertSpotifyCampaignForm',
  components: {
    AlertWraper,
    Button
  },
  props: ['campaign'],
  data () {
    return {
      content: null,
      content_type: 'error',
      loader: false,
      form: {
        platform_id: ''
      }
    }
  },
  created () {
    this.form.platform_id = this.currentLine?.platform_id ? this.currentLine.platform_id : ''
  },
  computed: {
    /**
     * Get audio creative
     */
    audios () {
      if (!this.campaign?.creatives) return null
      return this.campaign.creatives
    },
    /**
     * Get current line
     */
    currentLine () {
      if (!this.campaign) return null
      return this.campaign.packages[0].lines ? this.campaign.packages[0].lines[0] : null
    },
    /**
     * Get current package
     */
    currentPackage () {
      if (!this.campaign) return null
      return this.campaign.packages[0]
    }
  },
  methods: {
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      this.content = null
      try {
        const campaign = await CampaignsService.upsertYoutubeCampaignOnPlatform({
          campaignId: this.campaign.id,
          platformId: this.form.platform_id
        })
        this.$emit('upserted', campaign)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
